module.exports = "<div class=\"container\">\n  <event-description [event]=event [backButton]=true></event-description>\n</div>\n"